import { useEffect, useState } from "react";

import { getRepairDossierTransactionsStatus } from "../../api/dossier/getRepairDossierTransactionsStatus";
import { repairDossierTransactions } from "../../api/dossier/repairDossierTransactions";
import CatchELoadingButton from "./CatchELoadingButton";

const RepairDossierTransactionsButton = ({
  dossierId,
}: {
  dossierId: string;
}) => {
  const [isSyncing, setIsSyncing] = useState<boolean>(false);
  const { mutateAsync: mutateRepairDossierTransactionsAsync } =
    repairDossierTransactions();

  const repairDossierTransactionsStatus = getRepairDossierTransactionsStatus(
    dossierId,
    {
      mutationOptions: {
        successAlertMessage: isSyncing
          ? "Dossier transactions have been repaired successfully."
          : undefined,
        errorAlertMessage: isSyncing
          ? "Dossier transactions repair failed"
          : undefined,
      },
    }
  );

  useEffect(() => {
    if (repairDossierTransactionsStatus.isSuccess) {
      if (!isSyncing && repairDossierTransactionsStatus.data === "SYNCING") {
        // Sync was triggered
        setIsSyncing(true);
      } else if (
        isSyncing &&
        repairDossierTransactionsStatus.data !== "SYNCING"
      ) {
        // Sync was finished
        setIsSyncing(false);
      }
    }
  }, [repairDossierTransactionsStatus]);

  const onDossierTransactionsRepair = async () => {
    mutateRepairDossierTransactionsAsync({
      dossierId: dossierId,
    });
  };

  return (
    <>
      {repairDossierTransactionsStatus.isSuccess && (
        <CatchELoadingButton
          isLoading={isSyncing}
          inactiveText="Full Transaction Repair"
          activeText="Repairing"
          onClick={onDossierTransactionsRepair}
        />
      )}
    </>
  );
};

export default RepairDossierTransactionsButton;
